<template>
    <div>
        <router-view :key="$route.path"/>
        <portal-target name="modals-root"/>
    </div>
</template>

<script>
export default { name: 'App' };
</script>
